import React from "react";

export const headerColums = (league) => {
    return (
        <div
            style={{
                display: "grid",
            }}
        >
            <div>{league}</div>
        </div>
    );
};
